const b = (o, e) => {
  const s = o.style.display;
  s !== "block" && (o.style.display = "block");
  const l = o.getBoundingClientRect(), c = e.getBoundingClientRect(), t = c.top - l.top, i = l.bottom - c.bottom;
  t >= 0 && i >= 0 || (Math.abs(t) < Math.abs(i) ? o.scrollTop += t : o.scrollTop -= i), o.style.display = s;
};
export {
  b as scrollToChild
};
